import CustomMDXEditor from "@/components/shared/CustomMDXEditor";
import { UseFormReturn } from "react-hook-form";
import { useEffect, useRef, useState } from "react";
import { MDXEditorMethods } from "@mdxeditor/editor";
import { Button } from "@/components/ui/button";
import { useTranslation } from "react-i18next";
import { cn } from "@/lib/utils";

interface SummaryComponentProps {
  form: UseFormReturn<any>;
}

function SummaryComponent({ form }: SummaryComponentProps) {
  const { t } = useTranslation(["common"]);

  const editorRef = useRef<MDXEditorMethods>(null);

  const [isEditing, setIsEditing] = useState(false);

  const { watch, setValue } = form;
  const executiveSummary = watch("executiveSummary");

  // Update editor content when executiveSummary changes
  useEffect(() => {
    if (editorRef.current && executiveSummary) {
      editorRef.current.setMarkdown(executiveSummary);
    }
  }, [executiveSummary]);

  return (
    <div className="flex flex-col gap-1">
      <div className="flex items-center justify-between">
        <p className="text-sm text-slate-500">{t("components:createtendersidebar.summary.description")}</p>
        <Button variant="outline" size="sm" onClick={() => setIsEditing((prev) => !prev)}>
          {isEditing ? t("common:buttons.cancel") : t("common:buttons.edit")}
        </Button>
      </div>

      <CustomMDXEditor
        ref={editorRef}
        value={executiveSummary}
        readOnly={!isEditing}
        overwriteDefaultClasses={true}
        onChange={(value) => setValue("executiveSummary", value)}
        editableContentClassName={cn(
          "leading-normal max-w-full overflow-y-auto p-4 border-[1px] border-gray-300 rounded-md",
          isEditing ? "h-[calc(100vh-14rem)]" : "h-[calc(100vh-12rem)]"
        )}
      />
    </div>
  );
}

export default SummaryComponent;
